export const paramsInQueryStringFormat  = (paramsObject)  => {
    let formattedParams = [];
    Object.keys(paramsObject).forEach(function(key) {
        if(paramsObject[key])
            formattedParams.push(`${key}=${paramsObject[key]}`);
    });
    return `?${formattedParams.join('&')}`;
}